export const INTERFY_PRIVACY_POLICY_URL = 'https://interfy.ai/legal/privacy'

export function privacyPolicyUrl(domain, fallback) {
  const location = String((domain && domain.location) || '').toLowerCase().replace(/^www\./, '')
  return location === 'interfy.io' || location === 'interfy.ai'
    ? INTERFY_PRIVACY_POLICY_URL
    : fallback
}

export function privacyPolicyHtml(domain, html) {
  return html.replace(/\/privacy-policy\/\{lang\}/g, privacyPolicyUrl(domain, '/privacy-policy/{lang}'))
}
